module.exports = __webpack_public_path__ + "6c15e5055662b7a39745ee247bf1cba1.jpg";